import { z } from 'zod';
const strings = z.array(z.string()).nullable().optional();
export const loggerClassSchema = z
  .object({
    handling_class: z.string().nullable().optional(),
    class_basis: z.string().nullable().optional(),
    assignment_revision: z.number().int().nullable().optional(),
  })
  .passthrough();
export const evaluationClassSchema = z
  .object({
    class_mode: z.boolean().nullable().optional(),
    failing_classes: strings,
    groups: z
      .array(
        z
          .object({
            handling_class: z.string(),
            products: strings,
            spec_ids: strings,
            limits: z
              .object({
                combined: z.record(z.unknown()).nullable().optional(),
                description: z.unknown().optional(),
              })
              .passthrough()
              .nullable()
              .optional(),
            verdict: z.string().optional(),
            reason_code: z.string().nullable().optional(),
            loggers: z.array(loggerClassSchema).nullable().optional(),
          })
          .passthrough()
      )
      .nullable()
      .optional(),
    loggers: z.array(loggerClassSchema).nullable().optional(),
  })
  .passthrough();
export function parseClassResponse(path: string, response: unknown): unknown {
  if (/\/temperature\/evaluations\/[^/?]+(?:\?|$)/.test(path))
    return evaluationClassSchema.parse(response);
  if (/\/temperature\/logger-files\/[^/?]+(?:\?|$)/.test(path))
    return loggerClassSchema.parse(response);
  if (/\/temperature\/logger-files(?:\?|$)/.test(path))
    return z
      .object({ files: z.array(loggerClassSchema) })
      .passthrough()
      .parse(response);
  return response;
}
